import { buildStaticUrl } from '@/constants/endpoints';

export const STICKY_CTA_ID = 'sticky_app_cta';

export const STICKY_CTA_BRANCH_CAMPAIGN =
  'PRODUCT_EB_US_ACQ_ALLP_ALL_demand_gen_phase1';
export const STICKY_CTA_BRANCH_CHANNEL = 'website';
export const STICKY_CTA_BRANCH_FEATURE = 'homepage';
export const STICKY_CTA_BRANCH_STAGE = 'sticky app cta';
export const STICKY_CTA_QR_REFERRER_SOURCE = 'qr_code__sticky_app_cta';
export const STICKY_CTA_DOWNLOAD_REFERRER_SOURCE =
  'download_button__sticky_app_cta';

export const STICKY_CTA_APP_ICON = buildStaticUrl(
  '/web/assets/depop-logo-white.png'
);
